import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listCapabilities} from '../utils/utilsSolution';


import * as PD from '../classes/pdStyle';

class ListCapabilities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            Capabilities : null
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(Filters){

    const onLoad = (data) => {
        this.setState({
            isLoaded: true,
            Capabilities: data
        });

        if (this.state.onLoad){
            this.state.onLoad(data.length);
        }

    }
  
    const onFail = (error) => {
        this.setState({
            isFailed: true,
            isLoaded: false
        });
    }

    listCapabilities(this.dsd, Filters, onLoad, onFail);

}

setup(){

    let StateChange = {
        filters: {},
        data: null,
        columns: {
            owner:false,
            solution: false
        }
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    this.loadData(StateChange.filters);

    this.setState(StateChange);
        
}



    included(Capability) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.isFailed) {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.isLoaded) {
            let arrCapabilities = this.state.Capabilities;
            if (isArray(arrCapabilities)){
                if (arrCapabilities.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Type</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.logicalmodel &&
                                        <PD.Th>Solution</PD.Th>                            
                                    }

                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrCapabilities.map(
                                    (Capability, pos) => 
                                    {
                                        if (this.included(Capability)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/capability/" + Capability._id} > {Capability.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Capability.type}
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Capability.Solution){
                                                                        if (Capability.Solution.Owner){
                                                                            return Capability.Solution.Owner.organisation;
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.solution &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Capability.Solution){
                                                                        return Capability.Solution.name;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Capability.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListCapabilities_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListCapabilities {...props} navigation={navigation} location={location} params={params} />;
  }
